import { FC, ReactElement } from 'react';
import { useNavigate } from 'react-router-dom';

type PageHeaderWithBackProps = {
  title: string | ReactElement;
  description?: string | ReactElement;
  backHref?: string;
  backLabel?: string;
  onBack?: () => void;
  className?: string;
  actions?: ReactElement | null;
};

const PageHeaderWithBack: FC<PageHeaderWithBackProps> = ({
  title,
  description,
  backHref,
  backLabel,
  onBack,
  className,
  actions,
}) => {
  const navigate = useNavigate();
  const containerClassName = [
    'flex flex-col gap-3 pb-0 sm:flex-row sm:items-start sm:justify-between',
    className,
  ]
    .filter(Boolean)
    .join(' ');

  return (
    <div className={containerClassName}>
      <div className="flex-1 min-w-0">
        <h2 className="text-2xl font-semibold text-slate-800">{title}</h2>
        {description ? (
          typeof description === 'string' ? (
            <p className="mt-1 text-sm text-slate-500">{description}</p>
          ) : (
            <div className="mt-1">{description}</div>
          )
        ) : null}
      </div>

      <div className="ml-auto flex flex-col items-end gap-2">
        {actions ?? null}
        <button
          type="button"
          className="rounded-md border border-slate-200 px-2 py-1 text-xs font-medium text-slate-500 whitespace-nowrap transition hover:border-primary hover:text-primary"
          onClick={() => {
            if (onBack) {
              onBack();
              return;
            }

            if (backHref) {
              navigate(backHref);
              return;
            }

            navigate(-1);
          }}
        >
          ← {backLabel ?? 'Back'}
        </button>
      </div>
    </div>
  );
};

export default PageHeaderWithBack;
